import PulseLoader from "@hudson/ui/components/Loader/PulseLoader";

function RepriceLoader({ children }: { children: JSX.Element | string }): JSX.Element {
  return (
    <div className="flex">
      <PulseLoader className="mr-1" size={1} />
      <span className="text-gray-300">{children}</span>
    </div>
  );
}

export default RepriceLoader;
